import React from 'react';

import { containerClass } from './style.css';

import { useTranslation } from 'react-i18next';

const NoDataSection = () => {
	const { t } = useTranslation(['common', 'commonInfReport']);

	return (
		<div className={containerClass}>
			<p>{t('commonInfReport:features.report.no-data-section.no-data')}</p>
		</div>
	);
};

export default NoDataSection;
